import styled from "styled-components";
import { Link } from "react-router-dom";
import themeGet from "@styled-system/theme-get";

export const ColumnHeaderContainer = styled.div`
  background: transparent;
  margin: 0;
`;

export const ColumnHeaderLink = styled(Link)`
  text-decoration: none;
  display: block;
  padding: ${themeGet("space.r")};
  color: ${themeGet("colors.greyDarker")};
  transition: color 0.2s ease-in-out;
  &:hover,
  &:focus {
    color: ${themeGet("colors.primary")};
  }
`;

export const ColumnHeaderTitle = styled.div`
  font-weight: bold;
  font-size: ${themeGet("fontSizes.2")};
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  word-break: break-word;
`;
